import React from "react";
import s from './Friends.module.scss'

const Friends = (props) => {

  let fiendList = props.state.map(fr => {
    return <a key={fr.name} href={fr.link} className={s.friend}>
      <div className={s.friendsImage}>
        <img src={fr.avatar} alt='avatar' />
      </div>
      <div className={s.friendsInfo}>
        <p>{fr.name}</p>
      </div>
    </a>
  })
  return (
    <div className={s.friends}>
      <h3>Friends</h3>
      {fiendList}
    </div>
  );
}

export default Friends;